import { render, staticRenderFns } from "./PageDonatedFunds.vue?vue&type=template&id=5ab00606&scoped=true&"
import script from "./PageDonatedFunds.vue?vue&type=script&lang=ts&"
export * from "./PageDonatedFunds.vue?vue&type=script&lang=ts&"
import style0 from "./PageDonatedFunds.vue?vue&type=style&index=0&id=5ab00606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00606",
  null
  
)

export default component.exports